<template>
    <div class="fund-tile">
        <router-link :to="{ name: 'fundContent', query: { fund_id: fundId, title: fundName } }" class="text-decoration-none">
            <div class="fund-tile__thumbnail fund-tile__thumbnail--default rounded-lg">
                <div class="fund-tile-thumbnail__cover rounded-lg" :style="{ backgroundImage: `url(${thumbnailUri})` }"></div>
            </div>
        </router-link>
        <div class="fund-tile__body fund-tile-body" style="display: flex; flex-flow: column;">

            <router-link :to="{ name: 'fundContent', query: { fund_id: fundId, title: fundName } }" class="text-decoration-none">
            <div class="fund-tile-body__title">
                <div class="ellipsis1">
                    {{ fundName }}
                </div>
                <div class="fund-tile-body__author ellipsis1">{{ fundAuthor }}</div>
            </div>
            </router-link>

            <div class="flex-horizon">
                <div class="flex-horizon">
                    <v-chip class="fund-tile-body__chip" variant="outlined" :color="statusColor" :input-value="true" size="x-small" label>{{ nameStatus }}</v-chip>
                    <span v-if="investorCount" style="color: #666; font-size: 12px;">{{ investor }}人が出資しました</span>
                </div>
            </div>

            <div class="fund-tile-body__bottom">
                <div class="flex-horizon">
                    <div v-if="commentCount > 0" class="flex-horizon" style="color: #666; font-size: 12px;">
                        <v-icon>mdi-comment-outline</v-icon>
                        <span>{{ comment }}</span>
                    </div>
                    <div v-if="articleCount > 0" class="flex-horizon" style="color: #666; font-size: 12px;">
                        <v-icon>mdi-newspaper-variant-outline</v-icon>
                        <span>{{ article }}</span>
                    </div>
                </div>
                <div class="flex-horizon end">
                    <div style="color: #666; font-size: 12px;">{{ watcher }}人が登録中</div>
                    <v-btn
                        :loading="requesting"
                        id="id-watch-icon"
                        :class="{'checked': isWatched}"
                        background-color="white"
                        :ripple="false"
                        variant="text"
                        density="compact"
                        icon="mdi-heart"
                        size="small"
                        @click="onClickedWatch"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
const watchListApi = '/api/watch/item/save'
import Helper from "../assets/js/helper"
import FundLogic from "../composable/FundLogic"

export default {
    name: 'FundTile',
    props: {
        'watchListCount' : String,
        'investorCount' : String,
        'commentCount': String,
        'articleCount': String,
        'fundId': String,
        'fundName': String,
        'fundAuthor': String, 
        'fundStatus': String,
        'explanationShort': String,
        'thumbnailUri': String,
    },
    data: () => ({
        'isWatched': true,
        'requesting': false,
    }),
    computed: {
        watcher: function () {
            return Helper.addComma(this.watchListCount)
        },
        investor: function () {
            return Helper.addComma(this.investorCount)
        },
        comment: function () {
            return Helper.addComma(this.commentCount)
        },
        article: function () {
            return Helper.addComma(this.articleCount)
        },
        nameStatus: function () {
            return FundLogic.nameFundStatus(this.fundStatus)
        },
        statusColor: function () {
            return FundLogic.statusColor(this.fundStatus)
        },
        flushMessage: {
            set(value) {
                this.$store.dispatch("setFlushMessage", value);
            }
        }
    },
    // コンポーネントマウントリスナ
    mounted() { },
    methods: {
        onClickedWatch(){
            (async () => {
                try{
                    this.requesting = true;
                    var params = new URLSearchParams()
                    params.append('fund_id', this.fundId)
                    params.append('mode', this.isWatched ? 'del' : 'add' )
                    const response = await axios.post(watchListApi, params)
                    console.log(response)
                    this.isWatched = !this.isWatched

                    this.flushMessage = this.isWatched ? 'ウォッチリストに登録しました' : 'ウォッチリストを解除しました'

                }catch(error){
                    console.log(error)
                    alert('ウォッチリストの登録に失敗しました。画面右上のリロードボタンからページを更新後、再度お試しください。')
                }finally{
                    this.requesting = false;
                }

            })()
        }
    }
}
</script>

<style scoped>

.flex-horizon {
    display: flex;
    gap: 8px;
}

.flex-horizon.end {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
.fund-tile {
    display: flex;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
}

.fund-tile__thumbnail {
    width: 100px;
    min-width: 100px;
    aspect-ratio: 1;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.fund-tile__thumbnail--default {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-color: #aaa;
    background-image: url('../assets/images/empty.gif');
}

.fund-tile-thumbnail__cover {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.fund-tile__body {
    width: calc(100% - 100px - 12px);
}

.fund-tile-body {
    display: flex;
    flex-flow: column;
    gap: 4px;
    text-align: left;
}

.fund-tile-body__chip {
    margin-bottom: 4px;
}

.fund-tile-body__title {
    font-size: 14px;
}

.fund-tile-body__author {
    font-size: 12px;
    color: #666;
}

.fund-tile-body__bottom {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
}

#id-watch-icon{
    color: #cccccc;
}

#id-watch-icon.checked{
    color: #ff0000;
}
</style>
